import api from "./api";

export type PeriodicPrize = {
  id: string;
  period_type: "week" | "month";
  period_start: string;
  scope: "club" | "platform";
  scope_id: string | null;
  rank: number;
  user_id: string;
  points_awarded: number;
  awarded_at: string;
};

export async function listMyPrizes() {
  const { data } = await api.get<PeriodicPrize[]>("/periodic-prizes/me");
  return data;
}

export async function listRecentPrizes() {
  const { data } = await api.get<PeriodicPrize[]>("/periodic-prizes");
  return data;
}
